// extracted by mini-css-extract-plugin
export default {"loggingHeader":"LoggingHeader_loggingHeader__8JurC","headerText":"LoggingHeader_headerText__kgjE5","container":"LoggingHeader_container__7gTUo"};